
import saveAs from "file-saver";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";

import docxtemplater from "docxtemplater";

function loadFile(url: any, callback: any) {
    PizZipUtils.getBinaryContent(url, callback);
}

// This function creates a .docx file from a template and saves it. 
// It returns a Promise that resolves when the file is saved, or rejects if there's an error.
// So it is useful to use this function in an async context, and await its completion.
export function createAndSaveDocument(pFileName: string, pTemplatePath: string, pData: any): Promise<void> {
    return new Promise((resolve, reject) => {
        loadFile(pTemplatePath, function (error: any, content: any) {
            if (error) {
                reject(error);
                return;
            }

            const zip = new PizZip(content);
            const doc = new docxtemplater().loadZip(zip);
            doc.setData(pData);

            try {
                doc.render();
            } catch (renderError) {
                // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
                reject(renderError);
                return;
            }

            const out = doc.getZip().generate({
                type: "blob",
                mimeType:
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            });

            saveAs(out, pFileName + `.docx`);
            resolve();
        });
    });
}